import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { FacturaContrato } from '../models/factura-contrato.model';

@Injectable()
export class InvoiceService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig    
    ){}   

    getStatusActivate(contrato : string) : Observable<any>{        
        return this.http.get(this.api.url + '/invoice/status/' + contrato, { responseType: 'text'});
    }

    getActivate(contrato : string, estado : string) : Observable<boolean>{
        return this.http.get<boolean>(this.api.url + '/invoice/activate/' + contrato + '/' + estado);
    }

    getLastInvoicesContracts(tipoFacturas: string, contrato : string, numeroFacturas: string) : Observable<Array<FacturaContrato>>{
        return this.http.get<Array<FacturaContrato>>(this.api.url + '/invoice/getLastInvoicesContracts/' + tipoFacturas + "/" + contrato + "/" + numeroFacturas);
    }  
   
    generatePDFInvoice(prefijo: string, numeroDocumento : string, formato: string) : Observable<Blob>{
        return this.http.get(this.api.url + '/invoice/generatePDFInvoice/' + prefijo + "/" + numeroDocumento + "/" + formato, { responseType: 'blob'});
        //return this.http.get(this.api.urlGenerarFacturaPDF + '?prefijo=' + prefijo + '&documento=' + numeroDocumento + '&formato=' + formato, { responseType: 'blob'});
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/invoice.service.ts